import { useWatch } from '../../../contexts';

export const useElseIfClausesWatch = () => useWatch({ name: 'conditionalContent.elseIfClauses' });
